import {
    SliceFactory,
    FetchCollectionData,
    FetchItemDataType,
    ApiCollectionResponse,
} from '@europrocurement/l2d-redux-utils';
import {
    ConfigurationParameters as OffreConfigurationParameters,
    Configuration,
    OriginesApi,
    OriginesOrigineRead,
} from '../../../openApi/ApiOffre';
import { OFFRE_REDUCER_NAME, ORIGINE_SLICE_NAME } from '../constants';

export type OrigineApiObject = OriginesOrigineRead & Record<string, unknown>;

export type Origines = OrigineApiObject;

const mapperOrigines = function (origines: OrigineApiObject) {
    return {
        ...origines,
    } as Origines;
};

export function createOriginesSlice(configuration: OffreConfigurationParameters) {
    const conf = new Configuration(configuration);
    const api = new OriginesApi(conf);

    const fetchOriginesCollection: FetchCollectionData<OrigineApiObject> = ({ xIdSociete }) =>
        api
            .apiOriginesGetCollection({
                xIdSociete,
                page: 1,
                itemsPerPage: 1000,
            })
            .then((res) => res.data)
            .catch((error) => {
                console.error(error);
            }) as Promise<ApiCollectionResponse<OrigineApiObject>>;

    const fetchOffersItem: FetchItemDataType<OrigineApiObject> = () => {
        throw new Error('Unable to fetch a single origine');
    };

    const { slice: origineSlice, dataSourcesThunks: originesDataSourcesThunks } =
        SliceFactory.createSlice<OrigineApiObject, Origines>(
            ORIGINE_SLICE_NAME,
            OFFRE_REDUCER_NAME,
            [],
            fetchOriginesCollection,
            fetchOffersItem,
            mapperOrigines,
        );

    return { origineSlice, originesDataSourcesThunks };
}
